import React, { Component } from "react";
import { Button, Card, CardGroup, Modal } from "react-bootstrap";
import { Checkbox } from "@material-ui/core";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import L from "leaflet";
import { MapContainer, TileLayer, LayersControl, GeoJSON } from "react-leaflet";
import hash from "object-hash";
import Axios from "../../redux/axiosHandlerGeo";
import GeoJsonLayer from "./GeoJsonLayer";
import kanchanpur from "../../geojson/kanchanpur.json";
import { infastructure } from "../../variable/global";
// import kanchanpur from "../../geojson/bedkot.json";
import { MdPlace } from "react-icons/md";
import "leaflet/dist/leaflet.css";
import "../../assets/css/homePageDescription.scss";
import { connect } from "react-redux";

class MunicipalityDescription extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalShow: false,
            boundData: [],
            wholeGeojson: [],
            location: {
                lat: 27.938571,
                lng: 85.918619,
            },
            zoom: 11,
            checkbox: {},
            wholeGeoJSON: {},
            showGeoJSON: [],
            sectionTitle: "",
        };
    }
    // 	this.getMunicpalId = this.getMunicpalId.bind(this);
    // }

    // isGeoJsonAlreadyFetched = (field) => {
    // 	const { wholeGeoJSON } = this.state;
    // 	return Boolean(wholeGeoJSON[field]);
    // };

    // fetchGeoJSON = (changedData) => {
    // 	const body = {
    // 		industries: "institute/industries",
    // 		cultural_heritage: "institute/cultural_heritage",
    // 		gov_office: "institute/gov_office",
    // 		forest: "institute/forest",
    // 		offices: "institute/offices",
    // 		infrastructure: "institute/infrastructure",
    // 		economic: "institute/economic",
    // 		education: "institute/education",
    // 		security: "institute/security",
    // 		palika_related_office: "institute/palika_related_office",
    // 		public_places: "institute/public_places",
    // 		health: "institute/health",
    // 	};

    // 	return new Promise((resolve, reject) => {
    // 		Axios.get(`/api/geojson/${body[changedData]}`)
    // 			.then((result) => {
    // 				const wholeGeoJSON = this.state.wholeGeoJSON;
    // 				this.setState(
    // 					{
    // 						wholeGeoJSON: {
    // 							...wholeGeoJSON,
    // 							[changedData]: result.data,
    // 						},
    // 					},
    // 					() => resolve()
    // 				);
    // 			})
    // 			.catch((err) => reject());
    // 	});
    // };

    // arrangeAllOption = async () => {
    // 	const { checkbox } = this.state;

    // 	const showGeoJSON = [];
    // 	let dataToCheck = [];

    // 	dataToCheck = dataToCheck.concat(infastructure);
    // 	const data = dataToCheck.map(async (each, i) => {
    // 		if (checkbox[each.value]) {
    // 			if (!this.isGeoJsonAlreadyFetched(each.value))
    // 				await this.fetchGeoJSON(each.value);

    // 			showGeoJSON.push(this.state.wholeGeoJSON[each.value]);
    // 		}
    // 	});
    // 	// wait until all promises resolve
    // 	await Promise.all(data);

    // 	this.setState({ showGeoJSON });
    // };

    // handleChange = (e) => {
    // 	e.persist();
    // 	this.setState(
    // 		({ checkbox }) => ({
    // 			checkbox: {
    // 				...checkbox,
    // 				[e.target.name]: e.target.checked,
    // 			},
    // 		}),
    // 		this.arrangeAllOption
    // 	);
    // };

    // style(feature) {
    // 	let skin = "blue";
    // 	if (feature.properties.FIRST_GaPa === "Bhimdatta") {
    // 		skin = "green";
    // 	}
    // 	return {
    // 		fillColor: skin,
    // 		weight: 1,
    // 		opacity: 1,
    // 		color: "black",
    // 		fillOpacity: 0.3,
    // 	};
    // }

    componentDidMount() {
        const boundData = [
            {
                key: "पुर्व",
                keyEnglish: "East",
                value: "बेलबारी नगरपालिका",
                valueEnglish: "belbari Municipality",
                class: "col-md-12",
            },
            {
                key: "उत्तर",
                keyEnglish: "North",
                value: "केरावारी  गाउँपालिका",
                valueEnglish: "Kerabari Rural Municipality",
                class: "col-md-12",
            },
            {
                key: "पश्चिम",
                keyEnglish: "West",
                value: "इटहरी उप- महानगरपालिका ",
                valueEnglish: "Itahari Sub-Metropolitan Municipality",
                class: "col-md-12",
            },
            {
                key: "दक्षिण",
                keyEnglish: "South",
                value: "ग्रामथाम गाउँपालिका र बुढीगंगा गाउँपालिका ",
                valueEnglish:
                    "Gramtham Rural Municipality and Budiganga Rural Municipality",
                class: "col-md-12",
            },
            {
                key: "क्षेत्रफल",
                keyEnglish: "Area",
                value: "११०.१६ ( वर्ग कि.मी.)",
                valueEnglish: "110.16 (sq. Km.)",
                class: "col-md-12",
            },
            {
                key: " वडा संख्या",
                keyEnglish: "ward",
                value: "१२",
                valueEnglish: "12",
                class: "col-md-12",
            },
            {
                key: "अक्षांश तथा देशान्तर",
                keyEnglish: "latitude and longitude",
                value: "२६.६२८६८ , ८७.३४०४१",
                valueEnglish: "26.62868 , 87.34041",
                class: "col-12",
            },
            // {
            // 	key: "मुख्य सहरी क्षेत्र",
            // 	keyEnglish: "Main city area",
            // 	value: "",
            // 	class: "col-12",
            // },
        ];
        this.setState({ ...this.state, boundData });
    }
    getMunicipalBounds() {
        let modalClose = () => this.setState({ modalShow: false });
        return (
            <div className="col-lg-5 pb-5 d-flex">
                <Card>
                    <Card.Body>
                        <div className="d-flex pb-8">
                            <SVG
                                className="primary-icon"
                                src={toAbsoluteUrl(
                                    "media/hamropalika/svg/map_marker.svg"
                                )}
                                alt=""
                            />
                            <h2 className="font-weight-black pl-3 pt-6 homepage-heading">
                                {this.props.selectedLanguage == "nepali"
                                    ? "सिमाना"
                                    : "Boundaries"}
                            </h2>
                        </div>
                        <div className="row">
                            {this.state.boundData.map((data, index) => {
                                return (
                                    <div
                                        className={`pb-3 ${data.class}`}
                                        key={index}
                                    >
                                        <div className="row">
                                            <div className="col-4">
                                                <h5 className="pr-2">
                                                    {this.props
                                                        .selectedLanguage ==
                                                    "nepali"
                                                        ? data.key
                                                        : data.keyEnglish}
                                                    :
                                                </h5>
                                            </div>
                                            <div className="col-8">
                                                <h5 className="text-primary">
                                                    {this.props
                                                        .selectedLanguage ==
                                                    "nepali"
                                                        ? data.value
                                                        : data.valueEnglish}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="float-right ">
                            <Button
                                className="px-10 emergency-button text-danger"
                                variant="light-danger"
                                size="lg"
                                onClick={() =>
                                    this.setState({ modalShow: true })
                                }
                            >
                                {" "}
                                <i className="icon-emergency"></i>{" "}
                                {this.props.selectedLanguage == "nepali"
                                    ? "आपतकालीन सम्पर्क"
                                    : "Emergency Contact"}
                            </Button>
                            {/* 
							<EmergencyContactModal
								selectedLanguage={this.props.selectedLanguage}
								show={this.state.modalShow}
								onHide={modalClose}
							/> */}
                        </div>
                    </Card.Body>
                </Card>
            </div>
        );
    }
    getMunicpalId() {
        return (
            <div className="col-lg-12 pb-5 d-flex ">
                <Card>
                    <Card.Body>
                        <div className="d-flex pb-8">
                            <SVG
                                className="primary-icon"
                                src={toAbsoluteUrl(
                                    "media/hamropalika/svg/municipality_id.svg"
                                )}
                                alt=""
                            />
                            <h2 className=" pl-3 pt-6 homepage-heading">
                                {this.props.selectedLanguage == "nepali"
                                    ? "गाउँपालिका अबस्थित  नक्शा"
                                    : "Rural Municipality Location Map"}
                            </h2>
                        </div>

                        <h4 className="col-lg-6 pb-5 d-flex">
                            {this.props.selectedLanguage === "nepali"
                                ? "सुन्दरहरैँचा नगरपालिका नेपालको बागमती प्रदेश, मध्यमाञ्चल विकास" +
                                  "क्षेत्र अन्तर्गत सिन्धुपाल्चोक जिल्लामा अवस्थित गाउँपालिका हो ।" +
                                  "विसं २०७३ सालमा नेपालको नयाँ प्रादेशिक संरचना कायम गर्दा समावेस" +
                                  "भएका साविक गाविसहरू: लिस्तीकोट, तातोपानी, फुल्पिङकट्टी र मार्मिङ" +
                                  "गाविस मिलेर सुन्दरहरैँचा नगरपालिका घोषणा गरिएको हो।चिन संङ्ग सिमाना" +
                                  "जोडिएर बसेको पहाडको एक नेपालकै मुख्य नाका रहेको तातोपानी भन्सार," +
                                  "अग्ला चट्टान सहितको पहाडी भूभाग रहेको नेपालको उत्तरी क्षेत्रमा" +
                                  "यस सुन्दरहरैँचा नगरपालिका रहि आएको छ| मुख्य रूपमा नेपाली, तामाङ" +
                                  "शेर्पा भाषा तथा बौद्ध धर्मालम्बीहरुको बाहुल्यता सहित विभिन्न" +
                                  "नेपाली संस्कृतिको समिश्रण रहेको देखिन्छ| यस गाउँपालिकाको" +
                                  "केन्द्र: साविकको फुप्लिङकट्टी गाविस : हाल वडा ४ टोल हिन्दीमा" +
                                  "रहेकोछ |" +
                                  "प्रदेश : कोशी प्रदेश " +
                                  "क्षेत्रफल : २५९०५ वर्ग कि.मि." +
                                  "महानगरपालिका  : १ उपमहानगरपालिका : २    नगरपालिका : ४६     गाउँपालिका : ८८ " +
                                  "जिल्ला : मोरङ " +
                                  "क्षेत्रफल : १८५५ वर्ग कि. मि." +
                                  "स्थानीय तह : सुन्दरहरैचा नगरपालिका :  ११०. १६ वर्ग कि. मि.  वडा सङ्ख्या : १२"
                                : "Bhotekoshi is a Rural Municipality in Sindhupalchowk district in" +
                                  "Bagmati Province, of Nepal. The former VDCs: Listikot, Tatopani," +
                                  "Fulpingkatti and Marming VDCs have been declared as Bhotekoshi" +
                                  "Rural Municipality in 2073 BS when the new provincial structure" +
                                  "of Nepal was established. Bhotekoshi is a Municipality in the" +
                                  "northern part of Nepal, which is a hilly region with high" +
                                  "cliffs, There seems to be a mixture of different Nepali" +
                                  "cultures, mainly Nepali, Tamang Sherpa language and Buddhist in" +
                                  "majority. Center of this Rural Municipality: Fuplingkatti VDC of" +
                                  "Savik: Currently Ward 4 is in Hindi." +
                                  "Province: Koshi " +
                                  "Province Area: 25905 sq km." +
                                  "Metropolitan City: 1 Sub-metropolitan City: 2 Municipality: 46 Rural Municipality: 88" +
                                  "District: Morang " +
                                  "Area: 1855 sq. km. M" +
                                  "Local level: Sundararaicha Municipality: 110.16 square km. M" +
                                  "Number of Wards: 12"}
                        </h4>

                        {/* <div className="d-flex pb-8">
							<SVG
								className="primary-icon"
								src={toAbsoluteUrl("media/hamropalika/svg/map_marker.svg")}
								alt=""
							/>
							<h2 className="font-weight-black pl-3 pt-6">
								{this.props.selectedLanguage == "nepali"
									? "सिमाना"
									: "Boundaries"}
							</h2>
						</div> */}
                        <div className="col-lg-5 pb-5 d-flex">
                            <div className="row">
                                {this.state.boundData.map((data, index) => {
                                    return (
                                        <div
                                            className={`pb-3 ${data.class}`}
                                            key={index}
                                        >
                                            <div className="row">
                                                <div className="col-4">
                                                    <h5 className="pr-2">
                                                        {this.props
                                                            .selectedLanguage ==
                                                        "nepali"
                                                            ? data.key
                                                            : data.keyEnglish}
                                                        :
                                                    </h5>
                                                </div>
                                                <div className="col-8">
                                                    <h5 className="text-primary">
                                                        {this.props
                                                            .selectedLanguage ==
                                                        "nepali"
                                                            ? data.value
                                                            : data.valueEnglish}
                                                    </h5>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                        {/* <img
							className="w-100"
							src={toAbsoluteUrl("/media/hamropalika/bhotekoshiStatic.png")}
							alt=""
						/> */}
                    </Card.Body>
                </Card>
            </div>
        );
    }
    render() {
        return (
            <>
                <Card>
                    <Card.Body>
                        <Card.Title className="d-md-flex justify-space-between row">
                            <div className="d-flex col-md-6">
                                <SVG
                                    className="primary-icon"
                                    style={{ width: "32px" }}
                                    src={toAbsoluteUrl(
                                        "media/hamropalika/svg/municipality_id.svg"
                                    )}
                                    alt=""
                                />
                                <h2 className="font-weight-black pl-3 pt-5 homepage-heading">
                                    {this.props.selectedLanguage == "nepali"
                                        ? "गाउँपालिका संक्षिप्त परिचय"
                                        : "Municipality Brief introduction"}
                                </h2>
                            </div>
                            <div id="destination">
                                <h2 className="font-weight-black pl-3 pt-5 homepage-heading">
                                    <MdPlace
                                        id="destination-icon"
                                        style={{ width: "32px" }}
                                    />{" "}
                                    {this.props.selectedLanguage == "nepali"
                                        ? "पर्यटकीय तथा महत्वपूर्ण स्थान"
                                        : "Tourist and important places"}
                                </h2>
                            </div>
                        </Card.Title>
                        <Card.Text>
                            <div className="row">
                                <div className="col-md-12 d-md-flex ">
                                    <div
                                        className="col-md-6 text-justify"
                                        id="intro-para"
                                    >
                                        <h4>
                                            {this.props.selectedLanguage ===
                                            "nepali"
                                                ? "डोटी जिल्ला सदरमुकाम सिलगढी डोटी बाट लगभग ६० किलोमिटर टाढा दक्षिण पश्चिम दिशा तिर पर्ने रमणीय उपत्यकाको नाम नै जोरायल हो । यस गाउँपालिका क्षेत्रको नाम “जोरायल” किन रहन गयो भन्ने बिषयमा एकमत देखिदैन । तर महाभारतको कथा अनुसार क्रममा भीमले जरासन्ध नामक राक्षकलाई दुई तिघ्रा समातेर बिचोबिच च्यातेर फाल्दा एक भाग यस क्षेत्रमा परेको हुँदा जरासन्धबाट ‘जरालय’ हुँदै ‘जोरायल’ भएको हो भन्ने धेरैको मत छ । कौरवहरुसंग जुवा हारेपछि १२ बर्षको बनबास र एक बर्षको गुप्तबासका क्रममा संयोगले एकदिन उनीहरू ‘जोरायलको शिरस्थानस्थित चौड़ेथल महाभारत पर्वत’ मा आइपुगे । चौड़ेथल जगत्तड़ी पर्वतको बसाइसितै एकदिन त्यहाँबाट तलतिर पर्ने ‘जोरायल’को भौगोलिक दृश्य हेर्न जाँदा चौतर्फी भौगोलिक एवं प्राकृतिक सुन्दरताले ओतप्रोत भएको र बीचमा उपत्यका जस्तो परेकोसम्म फाँटलाई जलमग्न अवस्थामा देखे । त्यो जलमग्नताको रहस्य बुझ्न समग्र भूगोल परीक्षण गर्दा त्यसको पुछारस्थान अर्थात् निकास मार्ग ‘नङ्गेउठी’ (बेत्थीखोला) भन्ने ठाउँमा वरपरबाट दुईवटा डाँडाहरू तलैसतह देखि आपसमा मिलेको र माथिको भाग एक आपसमा खुला रहँदा सतहबाट पानी जम्मा भएर त्यसको झण्डै १०० मिटर माथिबाट पानी उतातिर छहरा जस्तो भई बग्दा जलमग्नता रहेको देखे ।उनीहरुले जोरायलको जल निकास गरेर त्यसलाई बस्ती योग्य बनाइदिने योजना सहित दुई डाणाहरू जोडि़एको ठाउँ ‘नङ्गेउठीमा’ जल निकासमार्ग बनाए । यसरी जोरायलको जल निकास भइसकेपछि विगतमा जलमग्न स्थानको भू–भाग कहाँ के–कस्तो रहेछ भनी माथि हेर्दै जाँदा हालको सिलङ्गीबाग भन्ने ठाउँमा यौटा अजङ्ग र अर्धअंग भएको जीव त्यहाँ लडिबुडी गरिरहेको अवस्थामा देखियो । ‘मगधदेशमा राक्षस जरासन्धसँग भगवान श्रीकृष्णको युद्ध हुँदा पाण्डव भ्राता भीमले भगवान कृष्णको संकेतमा दुई खुट्टा समाति च्यातेर अर्ध अंग बनाई शरीरको यौटा आधा फक्लेटो आकास मार्ग तिर फाल्ने क्रममा कसरी–कसरी यहाँ आइपरेको प्रत्याभूति हुन पुग्यो किनभने मगधदेशमा भएको ‘जरासन्ध’+कृष्णयुद्धमा पाण्डव सखाहरू सहभागी थिए भन्ने कुरा श्रीमद्भावगत महापुराणको ‘दशंम–स्कन्ध’मा आख्यानात्मक वर्णन पाइन्छ ।" +
                                                  "राक्षस जरासन्धले त्यहाँका राजा–महाराजादेखि सर्वसाधारण जन जीवनमाथि हिंसात्मक आतंक र उपद्रव मचाएका कारण युद्धमा यस्तो दुर्दशा गरिएको कुरा अवगत भएपछि उसको सचेतन शारीरिक अर्धांशले पुनः जोरायल क्षेत्रमा पनि त्यसै किसिमको पीड़ा–आतंक पार्ला भन्ने पाण्डवहरूले जरासन्धको बध गरे । त्यसैले यसको नाम जोरायल रहन गएको हो भन्ने जनश्रुति छ ।यस्तै चारैतिर डाँडाकाडाँ भएको र विचमा समथर जग्गा भएको र उक्त जग्गा जलासययुक्त अवस्थामा रहेकोले पहिलो ‘जलासय’ नाम रहेको र पछि जलासयबाट अपभ्रंस हुँदै जोरायल भएको भन्ने भनाई पनि छ । जलनिकास भई बसोवास गर्न योग्य भएपछि उक्त स्थानमा बिभिन्न ठाउँका व्यक्तिहरु बसोवास गर्न आएका कारण यसलाई “जोडीजाडी जोरायल” भन्ने गरेको पनि सुनिन्छ । एकथरीको बुझाईमा जोरायलको शीर्षस्थानमा ‘ज्वालादेवी’ (जरादेवी) विराजमान भएकीले सोही नामाक्षरको आधारमा ‘जोरायल’ भएको हो भन्ने छ । भू–बनोट अनुसार भित्रीमधेश जस्तो ठाउँ हुँदा विगतमा यहाँ औलो ज्वरोको प्रकोप भइरहने हुँदा ‘जोरायल’ भएको हो भन्ने पनि छ ।समग्रमा हेर्दा जरासन्ध नामको राक्षकको अंगको एक भाग जोरायलमा परेको र त्यो भागको बध गरिएको हुँदा नै यसलाई जोरायल भनिएको हो भन्ने तर्क नै वलियो देखिन्छ ।"
                                                : "Zorayal rural municipality is located in the west-south part of Doti district, Far West province." +
                                                  "The district headquarters of this rural municipality is located 60 km west of Siliguri. It is named after the Zorayal Valley" +
                                                  "located here. This local level was formed in 2073 B.S. by bringing the then Ghanteshwar, Chatiwan, Saraswatinagar," +
                                                  "Laxminagar, Gadsera and Niraula village development committees into one committee.  It is surrounded by Badikedar rural municipality from the east" +
                                                  "Dadeldhura district from the west, Dadeldhura district from the north and Kailali district from the south."}
                                        </h4>
                                    </div>
                                    <div className="d-flex pb-8 d-sm-block d-md-none col-md-6 justify-content-start">
                                        <h2 className="font-weight-black pl-3 pt-5 homepage-heading text-left">
                                            <MdPlace
                                                id="destination-icon"
                                                style={{ width: "32px" }}
                                            />{" "}
                                            {this.props.selectedLanguage ==
                                            "nepali"
                                                ? "पार्यटकीय तथा महत्वपूर्ण स्थान"
                                                : "Tourist and important places"}
                                        </h2>
                                    </div>
                                    <div className="col-md-6 overflow-auto">
                                        <div className="card-content text-justify">
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/photo1.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "छहरा झरना"
                                                                : "Chhahara Waterfall"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "यो छहरा रहेको स्थान सुदूरपश्चिम प्रदेश, डोटी जिल्लाको साविक छतिवन गा.वि.स.को वडा नं. ४ र हाल जोरायल गा.पा को वडा नं. २ को क्षेत्र भित्र पर्दछ | प्रत्येक वर्ष चैत्र मसान्तको राति देखि भोलिपल्ट नववर्ष वैसाख १ गतेको बिहान १०/११ बजे सम्म मेला लाग्ने यस ठाउँमा यस क्षेत्रका गाउँ छिमेक मानिसहरुले स्नानका अतिरिक्त आफ्ना सन्ततिहरुको विवाह-ब्रतबन्धको काम समेत गर्दछन् भने यसक्षेत्रका कतिपय शक्तिशाली देवी-देवताहरुको भणार नुहाउनेकाम पनि यसै ठाउँमा गरिन्छ |"
                                                            : "The ‘Chhahra Jharna’ located in Jorayal village municipality of Doti district is being established as a tourist attraction. Tourists come here daily to see the beautiful view of the waterfall that falls from a height of about 100 meters." +
                                                              "Located 10 km east of Doti’s Budar Bazaar, this waterfall carries the same amount of water in twelve months. The fountain of water falling from the waterfall has lured the minds of tourists comming from various districts. Tourists have been enjoying the beautiful view of the surrounding forest and the chirping of birds and the chirping waterfall in the cold place. Not only this, because of the religious beliefs of this place, hundreds of devotees come here to bath. According to the locals, most of the devotees come in the month of Magh and Baishakh."}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/photo2.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div
                                                    className="card-body"
                                                    id="card-body"
                                                >
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "छतिवन ताल"
                                                                : "Chhativan Lake"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left overflow-hidden">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? ""
                                                            : ""}
                                                    </p>
                                                </div>
                                            </div>
                                            {/* <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/pic3.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "शिद्धेश्वर शिव मन्दिर, वडा नं. ८ सुर्खेत"
                                                                : "Hasina Wetlands"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "वडा नं. ८ मा रहेको यस शिद्धेश्वर शिव मन्दिरमा भगवान शिवको पुजा आराधना गर्ने गरिन्छ ।वि.सं. २०४९ सालमा भगवान शिवको सानो मुर्ती स्थापना गरि यस मन्दिर निरन्तर सञ्चालनमा रहेको छ । पछि २०५७ सालमा संरचनागत रुपमा मन्दिरको स्थापना भएको र नियमित रुपमा भगवान शिवको पुजाआजा गरिएको छ । मन्दिरको नाममा एक कठ्ठा जमिन रहेको र मन्दिर भित्र शिव र पार्वतीका मुर्तीहरु स्थापना गरिएको छ ।" +
                                                              "सम्पर्क व्यक्ति वा संस्थाः पुजारी, नरेश्वर चालिस ९८४८१६७९८०" +
                                                              "दर्ता विवरणः जि. प्र. का. सुर्खेतमा २०५७ सालमा शिद्धेश्वर शिव सेवा केन्द्को नाममा दर्ता भएको " +
                                                              "भौतिक अवस्थाः मन्दिरको नाममा १ कठ्ठा जग्गा रहेको छ । मन्दीरमा शिव पार्वती देवताहरुका मुर्तीहरु रहेका छन् । " +
                                                              "साथै शिवलिंग पनि रहेको छ। मन्दीरका २ वटा कोठाहरु भाडामा दिइएको छ ।" +
                                                              "सडकको अवस्थाः पक्की सडक" +
                                                              "अनुमानित समयः मंगलगढीबाट २ कि.मि. दुरीमा रहेको, गाडीमा ५ मिनेट ।" +
                                                              "अवलोकन गर्न लाग्ने समयः १५ मिनेट ।" +
                                                              "विशेष दिन र समयः श्रावणको प्रत्येक सोमवार, शिवरात्री, तिज" +
                                                              "सञ्चालन हुने गतिविधिः भजन कृतन र पुजा आजा, विवाह र ब्रतबन्ध"
                                                            : "Located in Ward No. 5 Hasina Tol, this Hasina Wetland is spread over an area of ​​49 hectares At first glance, the Hasina wetlands, which look like small hillocks, are not mountains, but a scrubland. Religious areas such as Buddha Bihar, Buddha Pond, Budhasubba Temple, Nag Pond, Sakela Than, Shivalaya Temple etc. have also been built in the wetland area. This area is also becoming an attractive destination for religious tourists There are many temples of Gods and Goddesses, various species of plants, animals, and animals Different species of wild animals and birds including wild boar, deer, cow, rabbit, forest fowl, guinea fowl and monkey are found in this area."}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/pic2.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "राधाकृष्ण मन्दिर, वडा नं. ८ सुर्खेत"
                                                                : "New Vrindavan Gaushala: Sundarharaicha"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "वीरेन्द्रनगर नगरपालिका क्षेत्रको प्रमुख राधाकृष्ण मन्दिरका रुपमा रहेको यो मन्दिर वि.सं.२०२९ सालमा स्थानिय वासीहरुको सहयोग एवं प्रयासमा निर्माण भएको हो । यो मन्दिर २०५८ सालमा पुर्ननिर्माण गरि पक्की आकर्षक मन्दिरका रुपमा रहेको छ । यस मन्दिरघण्टाघरबाट करिव एक किलोमिटर पूर्वमा एअरपोर्ट जाने सडकको काल∙चोकमा रहेको छ ।" +
                                                              "मन्दिरमा नियमित रुपमा विहान साँझ भगवान राधाकृष्णको पुजाआजा गरिन्छ । यसका अलावा भजनकृतन, रामायण, महाभारत पठन आदि क्रियाकलापहरु सञ्चालन हुने गर्दछन् । विशेषत श्रीकृष्ण जन्मअष्टमीमा दर्शनार्थीको ठुलो भिड लाग्नुका साथै उक्त अवसरमा यस मन्दिरमा भव्य भजनकृतन गरि श्रीकृष्ण भगवानको सोभा रत समेत निकाल्ने र वीरेन्द्रनगर बजार परिक्रमा गर्ने चलन रहेको छ ।" +
                                                              "मन्दिरमा राधाकृष्ण पञ्चायत देवताको मुर्ती स्थापना गरिएको छ । मन्दिरको नाममा १ कठ्ठा जमिन, पुजाआजाका लागि मन्दिर, सभाहल लगाएतका भौतिक संरचनाहरु रहेका छन् ।"
                                                            : "This Vrindavan Cowshed is being constructed towards Sundararaicha Municipality Ward No. 5 Budhikhola in order to promote the development of religious tourism sector. In the Dwapara Yuga, the campaign to build the holy shrine Vrindavan Gaushala, where Lord Krishna performed his Krishna Leela, has been started in New Vrindavan Gaushala. The construction of this religious village, which was started from four acres of land, has now reached an area of ​​more than seven bighas, and the largest Radhakrishna temple in Nepal is being built in that area."}
                                                    </p>
                                                </div>
                                            </div> */}
                                            {/* <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/tatopanibhansar.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "सुख्खा बन्दरगाह तातोपानी भन्सार"
                                                                : "Dry port hot water customs"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "तातोपानी गाउँ, सिन्धुपाल्चोक, बागमती प्रदेश ,  नेपालको उत्तरी सिमाना चीनसँग, काठमाडौंबाट ११४ किमी उत्तर पूर्वमा अवस्थित छ। लाङटाङको तातोपानी र रसुवा चीनसँगको नेपालको दुई मुख्य नाका हुन्। नेपाल निर्यात र आयात हुने समानहरुको चेक जांच सहित भन्सारको नियमित कार्य यहाँबाट हुने गरेको छ |"
                                                            : "Tatopani village, Sindhupalchowk, Bagmati province, Nepal's northern border with China, is located 114 km northeast of Kathmandu. Tatopani and Rasuwa of Langtang are the two main ports of Nepal with China. Regular customs operations are carried out from here, including check check of goods exported and imported from Nepal"}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="card" id="card">
                                                <img
                                                    className="card-img-top"
                                                    src={toAbsoluteUrl(
                                                        "media/description/dhugunagadhi.jpg"
                                                    )}
                                                    alt=""
                                                />
                                                <div className="card-body">
                                                    <h3>
                                                        <b>
                                                            {this.props
                                                                .selectedLanguage ===
                                                            "nepali"
                                                                ? "दुगुना गढी"
                                                                : "Double fortress"}
                                                        </b>
                                                    </h3>
                                                    <p className="card-text text-left">
                                                        {this.props
                                                            .selectedLanguage ===
                                                        "nepali"
                                                            ? "सुन्दरहरैँचा नगरपालिका वडा नम्बर ३ मा पर्ने दुगुना गढीलाई देशको दश महत्त्वपूर्ण किल्ला मध्ये एक मानिन्छ |  इतिहासकारका अनुसार  तत्कालीन प्रधानमन्त्री जङ्गबहादुर राणाले सन् १८५५-१८५६ मा तिब्बतको आक्रमणबाट सहरको रक्षा गर्न निर्माण गरेको उल्लेख गरिएको छ ।"
                                                            : "Duguna Gadhi in Bhotekoshi Gaonpalika Ward No. 3 is considered as one of the ten most important forts in the country According to historians, it was built by the then Prime Minister Jung Bahadur Rana in 1855-1856 to protect the city from the invasion of Tibet."}
                                                    </p>
                                                </div>
                                            </div> */}
                                            {/* <div className="card" id="card">
												<img
													className="card-img-top"
													src="https://images.unsplash.com/photo-1656414563496-34686606f2ce?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80"
													alt=""
												/>
												<div className="card-body">
													<p className="card-text text-left">
														Some example text some example text. John Doe is an
														architect and engineer
													</p>
												</div>
											</div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card.Text>
                    </Card.Body>
                </Card>
                {/* <CardGroup id="card-group">
                    <Card className="col-lg-6 d-flex">
                        <Card.Body id="card-body">
                            <Card.Title id="card-title">
                                <div className="d-flex pb-2" id="map-icon">
                                    <SVG
                                        className="primary-icon"
                                        src={toAbsoluteUrl(
                                            "media/hamropalika/svg/map_marker.svg"
                                        )}
                                        alt=""
                                    />
                                    <h2 className="font-weight-black pl-3 pt-6 homepage-heading">
                                        {this.props.selectedLanguage == "nepali"
                                            ? "नगरपालिका अबस्थित नक्शा"
                                            : "Boundaries"}
                                    </h2>
                                </div>
                            </Card.Title>
                            <Card.Text>
                                <img
                                    // style={{ height: "50px", width: "100%" }}
                                    className="w-10"
                                    style={{ maxWidth: "350px" }}
                                    src={toAbsoluteUrl(
                                        "/media/hamropalika/bhotekoshiStatic.png"
                                    )}
                                    alt=""
                                />
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    <Card className="col-lg-6 pb-5 d-flex">
                        <Card.Body id="card-body">
                            <Card.Title>
                                <div className="d-flex pb-2 " id="map-icon">
                                    <SVG
                                        className="primary-icon"
                                        src={toAbsoluteUrl(
                                            "media/hamropalika/svg/map_marker.svg"
                                        )}
                                        alt=""
                                    />
                                    <h2 className="font-weight-black pl-3 pt-6 homepage-heading">
                                        {this.props.selectedLanguage == "nepali"
                                            ? "सिमाना"
                                            : "Boundaries"}
                                    </h2>
                                </div>
                            </Card.Title>
                            <Card.Text>
                                <div className="row">
                                    {this.state.boundData.map((data, index) => {
                                        return (
                                            <div
                                                className={`pb-2 ${data.class}`}
                                                key={index}
                                            >
                                                <div className="row">
                                                    <div className="col-4">
                                                        <h5 className="pr-2 text-left simana-data">
                                                            {this.props
                                                                .selectedLanguage ==
                                                            "nepali"
                                                                ? data.key
                                                                : data.keyEnglish}
                                                            :
                                                        </h5>
                                                    </div>
                                                    <div className="col-8">
                                                        <h5 className="text-primary text-left">
                                                            {this.props
                                                                .selectedLanguage ==
                                                            "nepali"
                                                                ? data.value
                                                                : data.valueEnglish}
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </Card.Text>
                        </Card.Body>
                    </Card>
                    {/* {this.getMunicpalId()} */}
                {/* {this.getMunicipalBounds()} */}
                {/*</CardGroup> */}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    selectedLanguage: state.ward.selectedLanguage,
});
export default connect(mapStateToProps)(MunicipalityDescription);
